import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

import ApiVersionConstants from "../constants/api-version-constants";
import { Column } from "../models/Column";
import { ExcelExportColumn } from "../models/ExcelExport";
import { FsJob } from "./../models/FsJob";

@Injectable({
  providedIn: "root",
})
export class FieldServiceService {
  private baseUrl = `${environment.apiConfig.uri}/${ApiVersionConstants.V_2}/fieldService`;

  constructor(
    private http: HttpClient,
    private translateService: TranslateService,
  ) {}

  getList(companyId: string) {
    return this.http.get<FsJob[]>(this.baseUrl + "/" + companyId);
  }

  get(companyId: string, jobNumber: string): Observable<FsJob> {
    return this.http.get<FsJob>(`${this.baseUrl}/${companyId}/${jobNumber}`);
  }

  public exportToExcel(companyId: string, columns: ExcelExportColumn[]): Observable<Blob> {
    const url = `${this.baseUrl}/downloadExcel/?&companyId=${companyId}`;
    return this.http.post(url, columns, { responseType: "blob" });
  }

  public getColumns(): Column[] {
    return [
      new Column("fsNumber", "fieldservice.jobnumber"),
      new Column("date", "fieldservice.date"),
      new Column("reason", "fieldservice.reason"),
      new Column("contactPerson", "fieldservice.contactperson"),
      new Column("employee", "fieldservice.maintechnician"),
      new Column("status", "fieldservice.status"),
    ];
  }

  public async getAllColumnsForExcelExport(): Promise<ExcelExportColumn[]> {
    const columns = this.getColumns();
    const exportColumns: ExcelExportColumn[] = [];

    columns.forEach(async (x) => {
      const translation = await this.translateService.get(x.title).toPromise();
      const col = new ExcelExportColumn(x.key, translation);
      exportColumns.push(col);
    });

    return exportColumns;
  }
}
